import * as yup from 'yup'

export const schema = yup.object().shape({
  deadlineDate: yup.string().required().nullable(),
  cause: yup.string(),
})

export default schema
